import React from 'react';
import { ClipLoader } from 'react-spinners';

const Loader = ({ size = 40, color = '#36bba5' }) => (
  <div style={{ display:'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <ClipLoader color={color} size={size} />
  </div>
);

export default Loader; 